import React from 'react';
import {Container, Typography, Box, List, ListItem, Divider} from '@mui/material';
import SectionTitle from "./SectionTitle";

const skillList = {
    managementSkills: [
        {
            title: 'End-to-End Product Design',
            description: 'Leading projects from research and ideation through prototyping and delivery'
        },
        {
            title: 'Cross-functional Collaboration',
            description: 'Working with developers, product managers, and stakeholders in international teams'
        },
        {
            title: 'Design System Creation',
            description: 'Building and maintaining global design systems to ensure consistency at scale'
        },
    ],
    technicalSkillsFe: [
        'Figma • Adobe XD',
        'Prototyping • Wireframing',
        'UI Design • Visual Design',
    ],
    technicalSkillsBe: [
        'User Interviews • Usability Testing',
        'Affinity Diagrams • Journey Maps',
        'Personas • Empathy Maps',
    ],
    technicalSkillsDevOps: [
        'Information Architecture • Sitemaps',
        'Competitive Analysis',
        'Low & High Fidelity Prototypes',
    ],
    other: [
        'HTML • CSS basics',
        'Coursera Google UX Design Certificate',
    ],
}


function Skills() {

    const renderItem = (item, index, family) => {

        const listItemSx = {justifyContent: 'center', textAlign: 'center'};

        if (typeof item === 'string') {
            return (
                <ListItem key={`${family}_${index}`} sx={listItemSx}>
                    <Typography fontSize={'large'}>{item}</Typography>
                </ListItem>
            )
        }
        if (typeof item === 'object') {
            return (
                <>
                    <ListItem key={`${family}_${index}`} sx={{...listItemSx, paddingBottom: 0}}>
                        <Typography fontSize={'large'} fontWeight={'bold'}>{item.title}</Typography>
                    </ListItem>
                    <ListItem key={`${family}_${index}`} sx={{...listItemSx, paddingTop: 0}}>
                        <Typography fontSize={'large'}>{item.description}</Typography>
                    </ListItem>
                </>
            )
        }
    }

    const titleProps = {
        variant: "h4",
        align: 'center',
        fontWeight: 'bold',
        paddingTop: '24px',
        paddingBottom: '24px'
    }

    const listStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
    }

    return (
        <Container sx={{ padding: '64px 0',  overflow: 'hidden'}}>
            <SectionTitle title={'Skills'} />
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Divider />
                <Typography {...titleProps}>
                    {'// Design Process'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.managementSkills.map((element, index) => (renderItem(element, index, 'managementSkills')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// Tools'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsFe.map((element, index) => (renderItem(element, index, 'technicalSkillsFe')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// User Research'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsBe.map((element, index) => (renderItem(element, index, 'technicalSkillsBe')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// UX Methods'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.technicalSkillsDevOps.map((element, index) => (renderItem(element, index, 'technicalSkillsDevOps')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

                <Typography {...titleProps}>
                    {'// Other'}
                </Typography>
                <List sx={listStyle}>
                    {skillList.other.map((element, index) => (renderItem(element, index, 'other')))}
                </List>
                <Divider sx={{paddingTop: '24px'}} />

            </Box>
        </Container>
    );
}

export default Skills;